<template>
  <div id="app">
    <keep-alive include="home">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import routerMap from './tracer/routeMap'
export default {
  name: 'App',
  watch: {
    $route: function (to, from) {
      const page = routerMap[to.path]
      if (!page) {
        return
      }
      this.$tracer.page(to.path)
    }
  }
}
</script>
<style lang="scss">
#app {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue